<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="she-was-a-shy-girl">
<p style="padding-top:150px;">She decided that the first dream she will achieve is to shift to Dubai and she did it; she shifted to another country, another city to meet new people and get new and good vibes. she said that she shifted to Dubai to achieve her life’s goals but the truth is that she shifted to Dubai to escape from her memories with her Ex. She left the most beautiful city in the world ‘Venice, Italy’. She left the place that she was born in trying to forget what happened, all the beautiful city had been painted in black colors and only the black after breakup, and that is what love does to us when we lose the beloved one even if you live in the most beautiful place, it will seem like abandoned house without the beloved one, after a while from struggling with her broken heart and struggling alone with her new life. She got a great position at a multinational company in Dubai, she started to achieve her goals in life, she gained her self-confidence again, she started to feel as a great woman again and she really was. She got rid of her shyness, and started to increase her friends circle, she handled her life without her Ex as it should be.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0006.vue?d85e833a